export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') },
	'salesforceSignupForm': { id: 'salesforceSignupForm', page: 'salesforceSignupForm', getter: () => import(/* webpackChunkName: 'salesforceSignupForm' */ 'components/bolt/salesforceSignupForm/salesforceSignupForm') },
	'groupSales': { id: 'groupSales', page: 'text', getter: () => import(/* webpackChunkName: 'text' */ 'components/bolt/text/text') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis', parent: 'boltHome' },
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "watchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore', parent: 'boltHome' }
];
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
